export enum TenantTsType {
    SKY = '1',
    ALP = '2',
    AMADEUS = '3',
    RATEHAWK = '4',
    DISCOVER = '5',
    GENERIC = '100',
}

export function getTenantKeyByValue(value: string): keyof typeof TenantTsType | undefined {
    return Object.keys(TenantTsType).find(
      (key) => TenantTsType[key as keyof typeof TenantTsType] === value
    ) as keyof typeof TenantTsType | undefined;
  };